import { userInfoService } from '../../service/userInfoService'
import router from '../../router'

export const namespaced = true

const getDefaultState = () => {
  return {
    userInfo: null,
  }
}
export const state = getDefaultState();

export const getters = {
  getUserInfo (state) {
    return state.userInfo
  },

}
export const mutations = {
  SET_USER_INFO (state, payload) {
    state.userInfo = payload
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  }

}

export const actions = {
  async fetchUserInfo ({ commit }) {
      const { data } = await userInfoService().fetchUserInfo()
      commit('SET_USER_INFO', data.data)
    return data.data;
  },
  resetState({ commit }) {
    commit('RESET_STATE')
  },

}
